<template>
  <div class="home-wrapper">
    <div class="home-search">
      <div class="search-style">
        <div class="icon-search"></div>
        <div class="input-box">
          <input
            type="text"
            v-model="itemName"
            class="input-container"
            placeholder="请输入服务名称"
          />
        </div>
        <div class="search-btn" @click="searchClick">搜索</div>
      </div>
    </div>
    <div class="home-container">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="serveList[0] ? '没有更多了' : '暂无数据'"
          :offset="100"
          @load="onLoad"
        >
          <div
            class="serve-item"
            v-for="(serve, i) in serveList"
            :key="i"
            @click="handleClick(serve.id)"
          >
            <div class="top-view">
              <div class="serve-title">{{ serve.name }}</div>
              <div class="serve-price">
                <div class="serve-price2">
                  <span class="price_1">¥</span>
                  <span>{{ serve.score }}</span>
                </div>
              </div>
            </div>
            <div class="serve-adress">
              <i class="adress-icon"></i>
              <span>{{ orginfo.branchName || "-" }}</span>
            </div>

            <div class="left-cr"></div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
const baseUrl = process.env.NODE_ENV === "production" ? "/app" : "/api";
import formatDate from "@/filters/formatDate";
import { getServelist, getServiceItems } from "@/api/attest";
const imgUrl1 = require("@/assets/1.png");
const imgUrl2 = require("@/assets/2.png");
const imgUrl3 = require("@/assets/3.png");
const imgUrl4 = require("@/assets/4.png");
const imgUrl5 = require("@/assets/5.png");
const imgUrl6 = require("@/assets/6.png");
const imgUrl7 = require("@/assets/7.png");
const imgUrl8 = require("@/assets/8.png");
const imgUrl9 = require("@/assets/9.png");
const imgUrl10 = require("@/assets/10.png");
const imgUrl11 = require("@/assets/11.png");
const imgUrl12 = require("@/assets/12.png");
export default {
  components: {},
  data() {
    this.imgUrl1 = imgUrl1;
    this.imgUrl2 = imgUrl2;
    this.imgUrl3 = imgUrl3;
    this.imgUrl4 = imgUrl4;
    this.imgUrl5 = imgUrl5;
    this.imgUrl6 = imgUrl6;
    this.imgUrl7 = imgUrl7;
    this.imgUrl8 = imgUrl8;
    this.imgUrl9 = imgUrl9;
    this.imgUrl10 = imgUrl10;
    this.imgUrl11 = imgUrl11;
    this.imgUrl12 = imgUrl12;
    return {
      itemName: "",
      loading: false,
      isLoading: false,
      finished: true,
      serveList: [],
      orginfo: {},
      pageNow: 1,
    };
  },

  methods: {
    // 判断照片
    imageOption(image, type) {
      if (image) {
        return image;
      } else {
        switch (type) {
          case "八助":
            return imgUrl1;
          case "助急服务":
            return imgUrl2;
          case "助餐服务":
            return imgUrl3;
          case "医疗保健":
            return imgUrl4;
          case "固定服务":
            return imgUrl5;
          case "室外活动陪护":
            return imgUrl6;
          case "家政服务":
            return imgUrl7;
          case "康复训练":
            return imgUrl8;
          case "文化娱乐":
            return imgUrl9;
          case "点餐服务":
            return imgUrl10;
          case "生活照料服务":
            return imgUrl11;
          case "精神慰藉":
            return imgUrl12;
        }
      }
    },
    searchClick() {
      if (!this.itemName) {
        this.serveList = []
      }
      this.pageNow = 1;
      window.sessionStorage.setItem("item_name", this.itemName);
      this.onRefresh();
    },
    handleClick(id) {
      this.$router.push({
        path: "/serveView",
        query: {
          id: id,
        },
      });
    },
    onLoad() {
      if (!this.itemName) {
        return false;
      };

      if (this.pageNow === 1) {
        return;
      } else {
        this.loading = true;
        this.getList();
      }
    },
    onRefresh() {
      if (!this.itemName) {
        return false;
      };

      this.pageNow = 1;
      this.serveList = [];
      this.finished = false;
      this.loading = true;
      this.getList();
    },
    getList() {
      getServelist({
        bid: this.$route.query.bid,
        branchId: this.$route.query.branchId,
        pageIndex: this.pageNow,
        itemName: this.itemName,
        community: this.$route.query.areaName,
      })
        .then((res) => {
          this.orginfo = res.data || {};
          this.loading = false;
          this.isLoading = false;
          if (res.data.ipageAssistServiceItems.records.length < 10) {
            this.finished = true;
          } else {
            this.pageNow++;
          }
          this.serveList = this.serveList.concat(
            res.data.ipageAssistServiceItems.records
          );
        })
        .catch(() => {
          console.log("haha");
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from.path);
      if (from.path == "/serveView") {
        let itemName = window.sessionStorage.getItem("item_name");
        if (itemName) {
          vm.itemName = itemName;
          vm.pageNow = 1;
          vm.getList();
        }
      }
    });
  },
};
</script>
<style lang="less" scoped>
.home-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  padding-top: 80px;
  .home-search {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 375px;
    background-color: #fff;
    padding: 21px 15px 10px;
    .search-style {
      position: relative;
      width: 346px;
      height: 36px;
      border: 1px solid #1779ff;
      border-radius: 18px;
      .icon-search {
        position: absolute;
        left: 14px;
        top: 10px;
        width: 16px;
        height: 16px;
        background: url("../../assets/search.png") no-repeat center;
        background-size: 100% 100%;
      }
      .input-box {
        position: relative;
        height: 36px;
        padding-left: 38px;
        padding-right: 60px;
      }
      .input-container {
        position: absolute;
        top: 0px;
        height: 36px;
        font-size: 16px;
        background: transparent;
        text-indent: 8px;
        &::placeholder {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #a5a5a5;
        }
      }
      .search-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 34px;
        background: linear-gradient(90deg, #1779ff, #4996ff);
        border-radius: 17px;
        font-size: 16px;
        line-height: 34px;
        text-align: center;
        color: #fff;
      }
    }
  }

  .home-container {
    height: auto;
    padding-left: 14px;
    padding-right: 15px;
    margin-top: 10px;
    background-color: #f5f5f5;
    .serve-item {
      position: relative;
      width: 346px;
      height: 96px;
      background: #ffffff;
      border-radius: 7px;
      margin-bottom: 12px;
      padding: 13px 17px 16px 17px;
      overflow: hidden;
    }
    .left-cr {
      position: absolute;
      left: 0;
      top: 0;
      width: 15px;
      height: 25px;
      background: url("../../assets/cr.png") no-repeat center;
      background-size: 15px 25px;
    }
    .top-view {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }
    .serve-title {
      width: 190px;
      height: 35px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #292a2d;
      line-height: 20px;
      word-break: break-all;
    }
    .serve-price2 {
      position: absolute;
      top: -10px;
      right: 0;
    }
    .serve-price {
      height: 20px;
      position: relative;
      color: #fb452d;
      font-size: 27px;
      font-family: PingFang SC;
      font-weight: 500;
      .price_1 {
        font-size: 14px;
        padding-right: 6px;
      }
    }
    .serve-adress {
      display: flex;
      align-items: center;
      width: 100%;
      height: 16px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #767676;
      line-height: 16px;
      word-break: break-all;
      .adress-icon {
        display: inline-block;
        width: 10px;
        height: 12px;
        background: url("../../assets/branch.png") no-repeat center;
        background-size: 10px 12px;
        margin-right: 5px;
      }
    }

    .img-box {
      width: 117px;
      height: 117px;
      background: #ededed;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      .img-have {
        position: absolute;
        top: 0;
        left: 0;
        width: 117px;
        height: 117px;
      }
      .img-null {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 31px;
      }
    }
    .right-view {
      position: absolute;
      top: 12px;
      right: 14px;
      width: 207px;
      height: 117px;
      padding-left: 13px;
    }
  }
}
</style>
